import React from "react";
import { match } from "ts-pattern";
import {
  ALERT_ICON_OUTLINE,
  CHECK_ICON,
  CLOCK_ICON,
  HOURGLASS_ICON,
} from "../../../utils/svgs_new";
import CircleIcon from "../../CircleIcon";

export default function ComplianceCircleIcon(props: {
  color: string;
  type: "issue" | "expiresSoon" | "dueSoon" | "compliant" | "pending";
}) {
  const icon = (() =>
    match(props.type)
      .with("issue", () => ALERT_ICON_OUTLINE)
      .with("expiresSoon", () => HOURGLASS_ICON)
      .with("dueSoon", () => HOURGLASS_ICON)
      .with("compliant", () => CHECK_ICON)
      .with("pending", () => CLOCK_ICON)
      .exhaustive())();

  return <CircleIcon color={props.color} icon={icon} fill="white" stroke="white" />;
}
